<div class="column">
  <section id="upcomingSessionsFaculty" class="bg-grey"
    [ngClass]="sessions != undefined && sessions.length > 0 ? 'upcoming-list' : ''">
    <div class="container">
      <div class="row" *ngIf="!isDisplayed">
        <div class="col text-center mb-4">
          <h2>Loading...</h2>
        </div>
      </div>
      <div *ngIf="isDisplayed">
        <div *ngIf="sessions != undefined && sessions.length > 0">
          <div class="row pb-3">
            <div class="col">
              <button type="button" class="btn mt-2 btn-top-add-session" [routerLink]="['/set-availability']"><span
                  class="ico">+</span><u class="no-text-decoration">Set Availability</u></button>
            </div>
          </div>
          <div class="row pb-3" *ngFor="let sess of sessions">
            <div class="col">
              <div class="card-session">
                <div class="row mobile-sessions">
                  <div class="col">
                    <h2>Date: {{ sess.date }} at {{ sess.time }} {{ sess.zoneAbbr }}</h2>
                    <h2>Topic: {{ sess.topic }}</h2>
                    <h2>{{participantLabel}}: {{ sess.participantFirstName }} {{ sess.participantLastName }}</h2>
                  </div>
                  <div class="col-4 btn-container">
                    <div class="button mb-3">
                      <button type="button" class="btn-cancel" (click)="joinSession(sess.id, sess.ts)">
                        Start Session
                      </button>
                    </div>
                    <div class="button-text">
                      <button type="button" class="btn-cancel" (click)="showDeleteModal(sess.id)">
                        Send Cancellation Note
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="isDisplayNot && (sessions==undefined || sessions.length < 1)">
          <div class="col no-session-text">
            No Upcoming Sessions
          </div>
          <div class="row pt-2 upcoming-btn">
            <div class="col text-center">
              <a type="button" class="btn btn-no-add-session mb-5" [routerLink]="['/set-availability']">Set
                Availability</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Terms Modal -->
    <div id="confirm-popup" *ngIf="deleteModalVisible">
      <div class="confirm-body mt-5">
        <div>
          <div class="row">
            <div class="col text-center">
              <p class="py-5">Are you sure you want to cancel your appointment?</p>
            </div>
          </div>
        </div>

        <div class="confirm-tray">
          <div class="row">
            <div class="col">
              <button type="button" class="btn btn-secondary bg-light text-purple"
                (click)="deleteModalVisible = false">No</button>
            </div>
            <div class="col">
              <button type="button" class="btn btn-primary bg-purple" (click)="deleteSession()">Yes</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>